import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faDownload, faCircle} from '@fortawesome/free-solid-svg-icons'

import './csvbutton.css'
import './filterpanel.css'

export default function CsvButton3 (props) {
  const csvTableId = props?.csvTable ?? "dispTable";
  return props?.csvClick ? renderB(props.csvClick, csvTableId, props?.toCSV, props?.file, props?.annotate) : null
}

function renderB (csvCallback, csvTableId, toCSV, file, annotate) {
  return (
    <div className="btnholder">
      <span className="csvbutton-dot" onClick={() => csvCallback(csvTableId, toCSV, file, annotate)}>
        <FontAwesomeIcon className="icon-nudge" icon={faDownload} color="#498679" />
      </span>
      <span className="btnlabel">Download CSV</span>
    </div>
  )
}
export function CsvButton4(props) {
  const csvTableId = props?.csvTable ?? "dispTable";
  return props?.csvClick ? renderC(props.csvClick, csvTableId, props?.toCSV, props?.file, props?.annotate) : null
}
function renderC (csvCallback, csvTableId, toCSV, file, annotate) {
  return (
    <span className="csvbutton-dot action-button" onClick={() => csvCallback(csvTableId, toCSV, file, annotate)}>
      <FontAwesomeIcon className="icon-nudge" icon={faDownload} color="#498679" />
    </span>
  )
}
export function CsvButton5(props) {
  const csvTableId = props?.csvTable ?? "dispTable";
  return (
    <span className="fa-stack row-button" onClick={() => props.csvClick(csvTableId, props?.toCSV, props?.file, props?.annotate)}>
      <FontAwesomeIcon icon={faCircle} color="#E3E2E5" className="fa-stack-2x" />
      <FontAwesomeIcon icon={faDownload} color="#257461" className="fa-stack-1x"  />
    </span>
  )
}